module.exports = __webpack_public_path__ + "102e4bfbded39f5a8539b5d218840929.svg";